module.exports = __webpack_public_path__ + "mobile/img/card-img4.730d5880.png";